module.exports = __webpack_public_path__ + "img/logo_koehnke_colored.f7493434.png";